// ExternalCompanyTmCalls.jsx
// 외부 회사별 일일콜현황 관리 페이지 (/admin/ext/:code/tm-calls)
// CallRegister 에 회사코드를 넘겨 재사용한다(adminMode = 담당자 선택·전체 조회).

import React from 'react';
import { useParams } from 'react-router-dom';
import { useExtCompany, ExtCompanyFallback } from './useExtCompany';
import CallRegister from '../tm/CallRegister';

// 콜만 "명시적 false 일 때만 차단" 이다 (undefined 는 통과) — 기존 동작 그대로.
const CHECK = { key: 'call', label: '일일콜현황', mode: 'not-false' };

export default function ExternalCompanyTmCalls() {
  const { code } = useParams();
  const { company, loading, error } = useExtCompany(code, CHECK);
  if (!company) return <ExtCompanyFallback loading={loading} error={error} />;

  return (
    <CallRegister
      key={company.code}
      adminMode
      companyCode={company.code}
      companyName={company.name}
    />
  );
}
